import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/video_example_1.mp4")